<template>
  <div class="app">
   <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
         <img class="navbar-brand-full" src="/img/logo.png" width="123" alt="Meta">
         <img class="navbar-brand-minimized" src="/img/logo.png" width="30" alt="Meta">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
         <b-nav-item class="px-3" to="/">Início</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="d-md-down-none logout">
        <b-nav-item class="px-3"><i class="icon-user"></i> {{ $root.usuario('user_name') }}</b-nav-item>
        <b-nav-item class="px-3" v-on:click="logout"><i class="icon-logout"></i> Logout</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
      </b-navbar-nav>
   </AppHeader>
   <div class="app-body">
      <AppSidebar fixed>
         <SidebarHeader/>
         <SidebarForm/>
         <SidebarNav :navItems="enabledMenus"></SidebarNav>
         <SidebarFooter/>
         <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
         <Breadcrumb :list="list"/>
         <div class="container-fluid">
            <router-view></router-view>
         </div>
      </main>
      <AppAside fixed>
         <!--aside-->
         <DefaultAside/>
      </AppAside>
   </div>
   <TheFooter>
      <!--footer-->
      <div class="ml-auto">
         <a href="http://meta.com.br">Meta</a>
         <span class="ml-1">&copy; 2018</span>
      </div>
   </TheFooter>
</div>
</template>

<style>
  .logout {
    position: fixed;
    right: 5px;
  }
</style>


<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },

  data () {
    return {
      nav: nav.items
    }
  },

  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },

    enabledMenus() {
      return this.nav.filter((item) => {
        if (this.$acl.check(item.rule)) {
          return item;
        }
      });
    },
  },

  methods: {
    logout() {
      this.$localStorage.set('user', '');
      this.$acl.change('unlogged');

      this.$router.push({ name: 'Login' });
    }
  }
}
</script>
